export class Marketingdetailmodel {
  constructor() {}
  public CampaignId: string;
  public UserIPAddress: string;
  public CreatedBy: string;
  public CreatedOn: string;
  public GuardianEmail:string;
}
